import { useCallback } from 'react';

import { IGTMData } from './types';
import { IAuth, useAuth } from '../../Auth';
import { EMarketplaceType, getMarketplaceType } from '../../utilities';
import { getTenantId, isTestEnv } from '../../utilities/tracker/utils';

const stripUndefined = (obj: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, val]) => val !== undefined)
  );

const getGA4MarketplaceType = (marketplace?: EMarketplaceType) => {
  switch (marketplace) {
    case EMarketplaceType.WEEKLY:
      return 'weekly';
    case EMarketplaceType.PREMIER:
      return 'extended';
    case EMarketplaceType.FIXED:
      return 'vault';
    default:
      return undefined;
  }
};

export const getGTMData = (
  data: IGTMData,
  authData?: IAuth,
  marketplace?: EMarketplaceType
) => {
  const profile = authData?.profile;
  const { userId, vaultAccountId } = profile ?? {};
  const tenantId = getTenantId();

  const gtmData = stripUndefined({
    ...data,

    // GA4
    authenticationState: !!profile && !!tenantId,
    marketplace: getGA4MarketplaceType(marketplace),
    pwccAccountId: userId,
    vaultAccountId,

    // Segment
    Marketplace: marketplace,
    'User ID': tenantId,
  });

  return gtmData;
};

export const useGTMDataLayer = () => {
  const authData = useAuth();
  const marketplace = getMarketplaceType();

  return useCallback(
    (gtmData: IGTMData) => {
      const data = getGTMData(gtmData, authData, marketplace);

      window?.dataLayer?.push(data);

      if (isTestEnv()) {
        // eslint-disable-next-line no-console
        console.log('Common Components GTM data:', data);
      }
    },
    [authData, marketplace]
  );
};
